import MyWorker from '@/services/compiler-refactor/web-worker-convert-image-blob/worker?worker';
import { getConvertParams } from '../pngConvert/utils/image.utls';

const webWorkers: Worker[] = [];

interface IWebWorkerRes {
  arraybuffer?: ArrayBuffer;
  cacheKey: string;
}

export const convertImageBlobByWorker = async (
  data: {
    imgPath: string;
    is16bpp: boolean;
    format: string;
    cacheKey: string;
  },
  webWorkerIndex: number
) => {
  const { imgPath, format, is16bpp, cacheKey } = data;
  // 需要使用png conver进行处理
  const params = await getConvertParams({
    imgPath,
    format,
    is16bpp
  });
  if (!params) throw '获取参数有误，请检查';
  const myWorker = webWorkers[webWorkerIndex ?? -1];
  const terminate = myWorker ? false : true;
  if (!myWorker) {
    console.warn('web worker不存在', webWorkerIndex);
  }

  return new Promise<IWebWorkerRes>((resolve, reject) => {
    myWorker.onmessage = (e) => {
      if (terminate) myWorker.terminate();
      const res = e.data as IWebWorkerRes;
      if (res) {
        resolve(res);
      } else {
        reject();
      }
    };
    myWorker.onerror = () => {
      if (terminate) myWorker.terminate();
      reject('web worker发生错误');
    };

    // postMessage to worker
    const { imgData, width, height, options } = params;
    myWorker.postMessage({ img: imgData, width, height, options, cacheKey });
  });
};

export const initWebworkers = (count: number) => {
  terminateWebworkers();
  for (let i = 0; i < count; i++) {
    if (!webWorkers[i]) webWorkers[i] = new MyWorker();
  }
};

export const terminateWebworkers = () => {
  webWorkers.forEach((worker) => {
    worker.terminate();
  });
  webWorkers.length = 0;
};
